<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center">
        </div>

        <div class="d-sm-flex align-items-center mt-10 mt-lg-0">
          <button @click="openAddDefinitionBox" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Add Definition
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive" style="overflow: visible;">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Definition Key
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Definition Name
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  Description
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="qwilrDefinition in filteredQwilrDefinitions" :key="qwilrDefinition.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinition.qwilrDefinitionKey }}
                </th>
                
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinition.qwilrDefinitionName }}
                </th>

                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ qwilrDefinition.description }}
                </th>

                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu" >
                      <li>
                        <a @click.prevent="goToQwilrDefinition(qwilrDefinition.id)" class="dropdown-item d-flex align-items-center" href="#" >
                          <i class="flaticon-settings lh-1 me-8 position-relative top-1"></i>
                          Setup
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="deleteDefinition(qwilrDefinition.id)"
                          ><i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Delete</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#" @click.prevent="openUpdateDefinitiondBox(qwilrDefinition)"
                          ><i
                            class="flaticon-edit lh-1 me-8 position-relative top-1"
                          ></i>
                          Update</a
                        >
                      </li>
                    </ul>
                </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
          <p class="mb-0 text-paragraph">
            Showing <span class="fw-bold">{{ filteredQwilrDefinitions.length }}</span> out of
            <span class="fw-bold">{{ totalQwilrDefinitions }}</span> results
          </p>
        </div>
      </div>
      <Lightbox v-if="showAddDefinitionBox" @close="closeAddDefinitionBox">
        <AddQwilrDefinition @definitionAdded="handleDefinitionAdded" @close="closeAddDefinitionBox"/>
      </Lightbox>
      <Lightbox v-if="showUpdateDefinitionBox" @close="closeUpdateDefinitionBox">
        <UpdateQwilrDefinition :definition="this.selectedDefinition" @definitionUpdated="handleDefinitionUpdated" @close="closeUpdateDefinitionBox"/>
      </Lightbox>
    </div>
    <div class="row">
      <div class="col-md-6">
        <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
            pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
            fs-md-15 fs-lg-16 m-5 bg-primary" type="button"> Back </button>
      </div>
    </div>
  </template>
  
  <script>
  import { GetQwilrDefinitions, DeleteQwilrDefinitionById } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';
  import { mapGetters} from 'vuex'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import AddQwilrDefinition from "./AddQwilrDefinition.vue";
  import UpdateQwilrDefinition from "./UpdateQwilrDefinition.vue";
  import Lightbox from '@/components/Common/LightboxWrapper.vue';

  export default {
    name: "QwilrTemplateInfo",
    components: {
      AddQwilrDefinition,
      UpdateQwilrDefinition,
      Lightbox
    },
    data() {
      return {
        searchQuery: "", 
        filteredQwilrDefinitions: [], 
        pageSize: 10, 
        pageIndex: 1, 
        totalQwilrDefinitions: 0, 
        totalPages: 1, 
        showUpdateLightbox : false,
        selectedRole : {},
        showAddDefinitionBox:false,
        showUpdateDefinitionBox:false
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
      async fetchQwilrDefinitionsByFilter(filter = "") {
        let data = await GetQwilrDefinitions();
        if(data)
        {
          this.filteredQwilrDefinitions = data.qwilrDefinitions;
          this.totalQwilrDefinitions = data.qwilrDefinitions.length;
        }

      },
      handleSearch(event) {
        event.preventDefault();
        const filter = this.searchQuery.trim();
        this.pageIndex = 1; 
        this.fetchQwilrDefinitionsByFilter(filter);
      },
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.pageIndex = page;
          this.fetchQwilrDefinitionsByFilter(this.searchQuery);
        }
      },
      async goToQwilrDefinition(id) {
        this.$router.push({ name: 'qwilrDefinitionPage', params: { id: id } });
      },
      async goToMainMenu() {
				this.$router.push({ name: 'IntegrationListPage'});
      },
      openAddDefinitionBox(){
        this.showAddDefinitionBox=true;
      },
      openUpdateDefinitiondBox(field){
        this.selectedDefinition=field;
        this.showUpdateDefinitionBox=true;
      },
      closeAddDefinitionBox(){
        this.showAddDefinitionBox=false;
      },
      closeUpdateDefinitionBox(){
        this.showUpdateDefinitionBox=false;
      },
      handleDefinitionAdded(){
        this.fetchQwilrDefinitionsByFilter("");
      },
      handleDefinitionUpdated(){
        this.fetchQwilrDefinitionsByFilter("");
      },
      async deleteDefinition(definitionId) {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const payload = { id: definitionId };
              let response = await DeleteQwilrDefinitionById(payload);  
              if (response.status === 200) {
                toast.success('Definition deleted successfully!', {
                  timeout: 2000,
                });
                this.fetchQwilrDefinitionsByFilter("");
              }
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              console.log(errorMessage);
              toast.error(`Failed to delete definition: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Definition deletion canceled.', { timeout: 2000 });
          }
        });

      }
    },
    created() {
      this.fetchQwilrDefinitionsByFilter();
    }
  };
  </script>


  